import classNames from "classnames";
import styles from "./index.module.scss";
import Link from "components/Link";

const DotIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={{ marginBottom: 4 }}
      width='3'
      height='2'
      viewBox='0 0 3 2'
      fill='none'
    >
      <circle cx='1.4165' cy='1' r='0.75' fill='black' />
    </svg>
  );
};

export const CompanyCardH5 = ({ company, lang }) => {
  const industryValue = company.company_tags;
  const { is_default_description } = company as any;
  const companyUrl = company?.company_url || "/";
  const country = company?.country_culture?.[0] || "";

  const preferred_job = company?.preferred_job;
  const salary_info = preferred_job?.salary_info || {};

  return (
    <Link
      className={styles.companyCardH5}
      to={"/" + lang + companyUrl}
      title={company?.company_name}
    >
      <div className={styles.topRoot}>
        <div className={styles.header}>
          <img
            alt={company?.company_name}
            src={company?.company_logo || company?.logo}
            className={styles.logo}
          />

          <div style={{ flex: 1, overflow: "hidden" }}>
            <div className={styles.name}>{company.company_name}</div>
            {Boolean(industryValue.length) && (
              <div
                className={styles.tags}
                style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
              >
                {industryValue.map((v, i) => {
                  return (
                    <>
                      {i !== 0 && (
                        <span style={{ margin: "0 8px" }}>
                          <DotIcon />
                        </span>
                      )}
                      <span className={styles.industryItem}>{v}</span>
                    </>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        <div className={classNames(styles.desc, is_default_description && styles.defaultDesc)}>
          {company?.description}
        </div>
      </div>

      {preferred_job ? (
        <Link className={styles.bottomJobContent} to={`/${lang}${preferred_job?.job_url}`}>
          <HotIcon className={styles.hotIcon} />
          <div className={styles.jobInfo}>
            <span className={styles.jobTitle}>{preferred_job?.function_job_title}</span>
            <span className={styles.jobSalary}>
              {salary_info?.text} {salary_info?.type_text ? `[${salary_info?.type_text}]` : ""}
            </span>
          </div>
        </Link>
      ) : (
        <div className={styles.bottomContent}>
          <span className={styles.numberFlag}>
            <span>{company.jobs_num}</span>
            <span className={styles.text}>{company.suffix_text}</span>
          </span>
          <span className={styles.country}>{country}</span>
        </div>
      )}
    </Link>
  );
};

const HotIcon = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    {...props}
  >
    <path
      d='M7.17303 16.4295C-2.62466 9.82539 7.69775 6.05237 8.22249 2.02954C10.3213 3.42867 11.5457 5.70255 10.6711 9.20064C11.7206 9.02572 12.5951 8.15115 13.1199 6.57711C16.0932 9.55046 13.7666 15.4224 10.1685 16.222C8.24445 15.1725 8.22249 14.098 7.17301 10.5999C6.29844 11.4745 6.29846 14.5055 7.17303 16.4295Z'
      fill='#F04438'
    />
  </svg>
);
